import { render, staticRenderFns } from "./kx.vue?vue&type=template&id=14f8c7ce&scoped=true&"
import script from "./kx.vue?vue&type=script&lang=js&"
export * from "./kx.vue?vue&type=script&lang=js&"
import style0 from "./kx.vue?vue&type=style&index=0&id=14f8c7ce&lang=less&scoped=true&"
import style1 from "./kx.vue?vue&type=style&index=1&id=14f8c7ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f8c7ce",
  null
  
)

export default component.exports